import { usePage } from "@inertiajs/react";

const useSettingsPageProps = () => {
    return usePage().props as unknown as {
        recaptchaSiteKey: string;
        eukaEmailAddress: string;
        versionText: string;
        appVersion: string;
        parentsNav: {
            id: number;
            route: string;
            name: string;
            isExternal: boolean;
        }[];
        isLegacyDocumentFeatureActive: boolean;
        termsConditionsUrl: string;
    };
};

export default useSettingsPageProps;
